/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import { toast } from "react-toastify";
import { ButtonPrimary } from "../../../ui/buttons";
import { LabSelect } from "../../../components/course/select";
import { CustomLabel } from "../../../ui/labels";

const ReasonForCancelModal = ({ toggle, isOpen, setShowBackupFileModal, motivos, setMotivoToCancel }) => {
  const [motivoValue, setMotivoValue] = useState(null);
  const [mostrarError, setMostrarError] = useState(false);

  const motivosCancelada = motivos ? motivos.filter((e) => e.label === "Cancelada") : [];
  const motivosOptions = motivosCancelada.map((e) => {
    return { label: e.text, value: e.text };
  });

  const handleReactSelectChange = (selected) => {
    setMotivoValue(selected);
  };

  const inputError = () => {
    const error = { error: false };

    if (motivoValue === null) {
      error.mensaje = "debe seleccionar un motivo";
    } else {
      error.error = false;
    }

    return error;
  };

  const messageError = inputError();

  const handleClick = () => {
    setMostrarError(true);
    if (messageError.mensaje) {
      toast.error(messageError.mensaje);
    } else {
      // se cambio el flujo para modificar el orden de los modales al cerrar la nota de pedido
      // handleCancelarMotivo(motivoValue.value);
      setMotivoToCancel(motivoValue.value);
      setShowBackupFileModal(true);
      toggle();
    }
  };

  return (
    <div>
      <Modal isOpen={isOpen}>
        <ModalBody>
          <>
            <div className="px-4 pt-4">
              <p style={{ fontSize: "18px" }}>Ingrese el motivo de cancelación de la nota de pedido</p>
            </div>
            <div className="col-md-10">
              {/* <div className="row"> */}
              <div className="">
                <div className="form-group">
                  <CustomLabel htmlFor="motivo" className="col-form-label pt-0 w-100">
                    Motivo de cierre
                    <LabSelect
                      border="solid 1px #ced4da"
                      id="motivo"
                      name="motivo"
                      className="w-100"
                      onChange={handleReactSelectChange}
                      value={motivoValue}
                      placeholder="Todo"
                      isClearable
                      // isLoading={isLoadingPiAsignable}
                      // isDisabled={isLoadingPiAsignable}
                      options={motivosOptions}
                    />
                  </CustomLabel>
                  {messageError && mostrarError && <div className="input-feedback text-center">{messageError.mensaje}</div>}
                </div>
              </div>
              {/* </div> */}
            </div>
          </>
        </ModalBody>

        <ModalFooter>
          <Button color="btn-secondary" onClick={toggle} type="button">
            Cancelar
          </Button>
          <ButtonPrimary onClick={handleClick} type="button">
            Confirmar
          </ButtonPrimary>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ReasonForCancelModal;
